<template>
    <h2> Ranking feature is coming soon </h2>
    <!-- <h3> View who owns the most NFTs, and view their NFT collections </h3> -->
    <div>
    <top-user
      v-for="nft in listedNFTs"
      :key="nft.id"
      :nftId="nft.id"
      :nftTitle="nft.title"
      :nftImg="nft.img"
      :nftPrice="nft.price"
    ></top-user>
    </div>

</template>

<script>
import TopUser from './TopUser.vue'
export default {
    inject: ["listedNFTs"],  
    props: ["nftId", "nftTitle", "nftImg", "nftPrice", "isListed"],
    components: { TopUser }
//     mounted() {
//         const theUserFromURL = this.$route.params.courseId;
//         this.user = theUserFromURL;
//     },
//     data() {
//         return {
//             user: "",
//         }
//     },
}
</script>

<style scoped>
div {
    background: white;
    padding: 10px;
    margin: 8px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
}
h2 {
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  background-color: darkcyan;
  padding: 1rem;
  color:white
}
</style>